__turbopack_context__.v({
  "card": "SlidesValidationCard-module__-LUN7a__card",
  "editable": "SlidesValidationCard-module__-LUN7a__editable",
  "verdict": "SlidesValidationCard-module__-LUN7a__verdict",
});
